import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error Could not find a declaration file for module
import StoredContentContainer from '../../containers/StoredContentContainer'; // @ts-expect-error Could not find a declaration file for module

import RecommendedLessonsContainer from '../../containers/LessonsPage/RecommendedLessonsContainer'; // @ts-expect-error Could not find a declaration file for module

import LessonInfoTabs from './LessonInfoTabs';
import { TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT, TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT, TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT, TRACK_RECOMMENDATIONS_URL_FRAGMENT } from '../../constants/Navigation';
import { NextPlaylistContentOverview, PlaylistComplete, PlaylistIncompleteItems } from '../../features/playlistContent';
import { LearningContentContainer } from '../../features/learningContent';

const LessonPage = ({
  lesson,
  contentId,
  onAdvanceContent,
  onResourceClick
}) => {
  switch (contentId) {
    case TRACK_RECOMMENDATIONS_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(RecommendedLessonsContainer, {
        lesson: lesson
      });

    case TRACK_NEXT_IN_PLAYLIST_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(NextPlaylistContentOverview, {
        lessonId: lesson.get('id') && Number(lesson.get('id'))
      });

    case TRACK_PLAYLIST_INCOMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistIncompleteItems, {});

    case TRACK_PLAYLIST_COMPLETE_URL_FRAGMENT:
      return /*#__PURE__*/_jsx(PlaylistComplete, {});

    default:
      return /*#__PURE__*/_jsxs(LearningContentContainer, {
        contentId: Number(contentId),
        lessonId: lesson.get('id'),
        children: [/*#__PURE__*/_jsx(StoredContentContainer, {
          contentId: contentId,
          isRequesting: lesson.get('isRequesting'),
          lessonId: lesson.get('id'),
          lessonName: lesson.get('name'),
          onFinish: onAdvanceContent
        }), /*#__PURE__*/_jsx(LessonInfoTabs, {
          lesson: lesson,
          onResourceClick: onResourceClick
        })]
      });
  }
};

export default LessonPage;